import { routes } from 'commons/constants/routes'
import { Application } from 'commons/types/DTO/bank/applications/list/webPage'
import {
  DateTime,
  Icon,
  IconName,
  Link,
  TableActions,
  TableActionsItem,
  TableColumn,
  Tooltip,
  UsPhoneLabel
} from 'ui/components'

import { EmailLink, IdWithNotes, Phone } from './styles'

export const columns =
  (onDeleteApplication: (companyName: string, id: number) => void, showGetLinkModal: (applicationId: number) => void) =>
  (): TableColumn<Application>[] => [
    {
      title: 'ID',
      align: 'left',
      width: '100px',
      render: ({ id, showInternalBankNotes }) => (
        <IdWithNotes>
          <Link to={routes.bank.application.details} params={{ applicationId: id.toString() }}>{`ID-${id}`}</Link>
          {showInternalBankNotes && (
            <Tooltip id={`ID-${id}`} type="dark" event="hover" content={<>{showInternalBankNotes}</>}>
              <Icon name={IconName.DIALOG} />
            </Tooltip>
          )}
        </IdWithNotes>
      )
    },
    {
      title: 'Company Name',
      align: 'left',
      render: ({ id, companyName }) => (
        <Link
          to={routes.bank.application.details}
          params={{ applicationId: id.toString() }}
          data-qa={`Company Name ${companyName}`}
        >
          {companyName}
        </Link>
      )
    },
    {
      align: 'left',
      title: 'Status',
      render: ({ status }) => <>{status}</>
    },
    {
      title: 'Contact Name',
      align: 'left',
      render: ({ contactName }) => <>{contactName}</>
    },
    {
      title: 'Email',
      align: 'left',
      render: ({ contactEmail }) => <EmailLink href={`mailto:${contactEmail}`}>{contactEmail}</EmailLink>
    },
    {
      title: 'Phone',
      align: 'left',
      render: ({ contactPhone }) => (
        <>
          {contactPhone && (
            <Phone>
              <UsPhoneLabel value={contactPhone} />
            </Phone>
          )}
        </>
      )
    },
    {
      title: 'Current Owner',
      align: 'left',
      render: ({ showCurrentOwner }) => <>{showCurrentOwner}</>
    },
    {
      title: 'Last Modified',
      align: 'left',
      sortable: true,
      key: 'lastModified',
      render: ({ lastModified }) => !!lastModified && <DateTime date={lastModified} />
    },
    {
      title: 'Created By',
      align: 'left',
      render: ({ showCreatedBy }) => <>{showCreatedBy}</>
    },
    {
      title: 'Action(s)',
      align: 'right',
      render: ({ getApplicationActionName, id, enableGetLink, enableDeleteApplication, companyName }) => {
        const items: TableActionsItem[] = [
          {
            type: 'option',
            title: getApplicationActionName,
            url: `${routes.bank.application.list}/${id}`
          },
          ...(enableGetLink
            ? [
                {
                  type: 'option' as const,
                  title: 'Get link',
                  onClick: () => showGetLinkModal(id)
                }
              ]
            : []),
          ...(enableDeleteApplication
            ? [
                {
                  type: 'delete' as const,
                  onClick: () => onDeleteApplication(companyName, id)
                }
              ]
            : [])
        ]

        return <TableActions items={items} />
      }
    }
  ]
